module.exports = __webpack_public_path__ + "img/banner_bg_1.2e377a7a.png";